import { DictionaryEvidence, TableColumn } from '@eas/common-web';
import { VoltageLevel } from '@models';

export function useColumns(): TableColumn<VoltageLevel>[] {
  const dictionaryColumns =
    DictionaryEvidence.useDictionaryColumns<VoltageLevel>();

  return [dictionaryColumns.columnName];
}
